import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../../utils/ajax'

class listsStore {
  @observable loading
  @observable years
  @observable list
  @observable pagination
  @observable categoryName

  constructor () {
    this.loading = false;
    this.years = [];
    this.list = [];
    this.pagination = {};
  }
  @action
  init = async(id,page,year) =>{
    const search = {};
    runInAction(()=>{
      this.loading = true;
    })
    this.__getYears();
    if (year !== 'none') {
      search['search.createTime'] = year
    }
    const category = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/category/id/${id}`);
    if(category && category.status === 0){
      return;
    }
    runInAction(()=>{
      this.categoryName = category.name;
    })
    if (page) {
      page--
    } else if (this.pagination.page) {
      page = this.pagination.page - 1
    } else {
      page = 0
    }
    search.page = page
    search['search.categoryId'] = id;
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/news/selectApproval`,search);
    if(res && res.status === 0){
      return;
    }
    runInAction(()=>{
      this.list = res.content;
      this.pagination = {
        total: res.totalElements,
        results: res.size,
        page: res.number + 1,
      }
      this.loading = false;
    })

  }
  //获取年份
  __getYears = () => {
    let arr = [];
    let date = new Date();
    let endYear = date.getFullYear();// 获取当前年份
    for (let i = endYear; i >= endYear-9; i--) {
      arr.push({
        year: i
      });
    }
    runInAction(()=>{
      this.years = arr;
    })
  }
}
export default new listsStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/homePage/content/Lists/store.js